import { render, staticRenderFns } from "./RegularIcon.vue?vue&type=template&id=3c12ac55"
import script from "./RegularIcon.vue?vue&type=script&lang=js"
export * from "./RegularIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports